@import 'styles/mixins';

.itemRow {
  display: flex;
  flex-direction: column;
  width: 100%;

  border-radius: 10px;

  &.error {
    background: rgba(236, 30, 40, 0.1);
  }

  &.warning {
    background: rgba(243, 215, 59, 0.2);
  }

  .content {
    flex: 1 1 auto;

    display: flex;
    height: 44px;
    padding: 10px;
    gap: 8px;
    align-self: stretch;
    justify-content: space-between;

    border-radius: 10px;

    .actionElementContainer {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .iconContainer {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;

      svg {
        height: 24px;
        width: 24px;
      }

      span {
        @include line-clamp(1);

        font-size: 16px;
        line-height: 150%;
        letter-spacing: 0.16px;
      }
    }
  }

  .validationErrorMessage {
    padding: 4px 10px 9px 10px;

    span {
      flex: 1 0 0;
      line-height: normal;
    }
  }
}
